import React, { useState } from "react";

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
  IconButton,
} from "@chakra-ui/react";
import Content from "components/Sidebar/components/Content";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";

// Assets
import {
  IoMenuOutline,
  IoArrowBackCircle,
  IoArrowForwardCircleSharp,
} from "react-icons/io5";
import useGeneral from "hooks/use-general";

function Sidebar(props: { routes: RoutesType[]; [x: string]: any }) {
  const { routes } = props;
  const [height, setHeight] = useState("250px");
  const [typeOne, setTypeOne] = useState(true);
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const { sideBarCollapse, handleSidebarCollapse } = useGeneral();
  // Chakra Color Mode
  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";
  const handleWidth = (type: boolean) => {
    if (type) {
      setHeight("250px");
    } else {
      setHeight("100px");
    }
    setTypeOne(type);
  };

  // SIDEBAR
  return (
    <Box
      display={{ sm: "none", xl: "block" }}
      position="fixed"
      minH="100%"
      p={4}
    >
      <Box
        display="flex"
        position="relative"
        bg={bgButton}
        cursor="pointer"
        top={!sideBarCollapse ? "125px" : "90px"}
        left={!sideBarCollapse ? "230px" : "80px"}
        boxShadow="1px 1px 2px black"
        p={2} // Adicione o espaçamento (padding) conforme necessário
        onClick={handleSidebarCollapse}
        w={8}
        borderRadius={40}
        zIndex={1}
        aria-label=""
      >
        {sideBarCollapse ? (
          <Icon
            cursor="pointer"
            as={IoArrowForwardCircleSharp}
            onClick={handleSidebarCollapse}
            fontSize="1rem"
          />
        ) : (
          <Icon
            cursor="pointer"
            onClick={handleSidebarCollapse}
            as={IoArrowBackCircle}
            fontSize="1rem"
          />
        )}
      </Box>

      <Box
        bg={sidebarBg}
        transition={variantChange}
        w={!sideBarCollapse ? "250px" : "100px"}
        h="80vh"
        m={sidebarMargins}
        minH="100%"
        borderRadius="2%"
        overflowX="hidden"
        boxShadow={shadow}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <Content routes={routes} type={sideBarCollapse} />
        </Scrollbars>
      </Box>
    </Box>
  );
}

// FUNCTIONS
export function SidebarResponsive(props: { routes: RoutesType[] }) {
  let sidebarBackgroundColor = useColorModeValue("white", "navy.800");
  let menuColor = useColorModeValue("gray.400", "white");
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ sm: "flex", xl: "none" }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: "pointer" }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex="3"
            onClick={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} type={true} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

export default Sidebar;
